import { KeyValue } from '@angular/common';

export interface BaseLog {
  appVersion: { container: string; core: string };
  userAgent: string;
  time: number;
  page: string;
  positionId: string;
  wizardCode: string;
  stepCode: string;
  data: LogData[];
}

export interface LogData {
  key: string;
  value: string | number | boolean;
}

export interface ErrorLog extends BaseLog {
  type?: 'http' | 'js';
  code?: string;
  message?: string;
  uuid?: string;
  corrId?: string;
  url?: string;
  status?: number;
  stack?: string;
}

export interface InfoLog extends BaseLog {
  message?: string;
}

export interface WarningLog extends BaseLog {
  warning?: string;
}

export interface HttpReqLog extends BaseLog {
  url?: string;
  responseType?: string;
  method?: string;
  body?: any;
  headers?: KeyValue<string, string>[];
}
